exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2KJ6LrvznrS6-suDZBvAbN{width:400px}html[dir] ._2KJ6LrvznrS6-suDZBvAbN{-webkit-box-shadow:none;box-shadow:none;border:none}._2esm1Y7Q6zIy1kVhU4Mmhw{color:\"[theme:white, default:#ffffff]\"}html[dir] ._2esm1Y7Q6zIy1kVhU4Mmhw{background-color:\"[theme:themePrimary, default:#0078D4]\";padding:15px 20px 20px}._1ZKsqS1qun9XChwaZqlf3O{font-size:28px;font-weight:100}html[dir] ._1ZKsqS1qun9XChwaZqlf3O{margin:0}.Ce4LF6IEzPvX9Yv03cX_9{font-size:14px;font-weight:400}._1ebvT_NCL2GU4MfEnFD2ym{color:\"[theme:themePrimary, default:#0078D4]\"}html[dir] ._1ebvT_NCL2GU4MfEnFD2ym{border:1px solid \"[theme:white, default:#ffffff]\";background-color:\"[theme:white, default:#ffffff]\"}._1ebvT_NCL2GU4MfEnFD2ym:hover{color:\"[theme:white, default:#ffffff]\"}html[dir] ._1ebvT_NCL2GU4MfEnFD2ym:hover{background-color:\"[theme:themePrimary, default:#0078D4]\"}", ""]);

// exports
exports.locals = {
	"callout": "_2KJ6LrvznrS6-suDZBvAbN",
	"container": "_2esm1Y7Q6zIy1kVhU4Mmhw",
	"title": "_1ZKsqS1qun9XChwaZqlf3O",
	"content": "Ce4LF6IEzPvX9Yv03cX_9",
	"button": "_1ebvT_NCL2GU4MfEnFD2ym"
};